/** @format */

import React, { ButtonHTMLAttributes } from "react";
import { ReactComponent as XCircle } from "bootstrap-icons/icons/x-circle.svg";

const QueryItem: React.FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <button
      {...props}
      className={`btn btn-lg btn-light shadow me-2 tag mb-2 ${className}`}
    >
      {children}
      <XCircle />
    </button>
  );
};

export default QueryItem;
